export enum EAddressField {
  MAIN_ADDRESS_FIELD = "MAIN_ADDRESS_FIELD",
  MAIN_STREET = "MAIN_STREET",
  MAIN_POSTAL_CODE = "MAIN_POSTAL_CODE",
  MAIN_CITY = "MAIN_CITY",
  MAIN_SUGGESTIONS = "MAIN_SUGGESTIONS",
  MAIN_HINT = "MAIN_HINT",
  MAIN_SUGGESTION_LIST = "MAIN_SUGGESTION_LIST",
  MAIN_COUNTRY = "MAIN_COUNTRY",
  MAIN_CLOSE_BUTTON = "MAIN_CLOSE_BUTTON",

  DELIVERY_ADDRESS_FIELD = "DELIVERY_ADDRESS_FIELD",
  DELIVERY_STREET = "DELIVERY_STREET",
  DELIVERY_POSTAL_CODE = "DELIVERY_POSTAL_CODE",
  DELIVERY_CITY = "DELIVERY_CITY",
  DELIVERY_SUGGESTIONS = "DELIVERY_SUGGESTIONS",
  DELIVERY_HINT = "DELIVERY_HINT",
  DELIVERY_SUGGESTION_LIST = "DELIVERY_SUGGESTION_LIST",
  DELIVERY_COUNTRY = "DELIVERY_COUNTRY",
  DELIVERY_CLOSE_BUTTON = "DELIVERY_CLOSE_BUTTON",

  BILLING_ADDRESS_FIELD = "BILLING_ADDRESS_FIELD",
  BILLING_STREET = "BILLING_STREET",
  BILLING_POSTAL_CODE = "BILLING_POSTAL_CODE",
  BILLING_CITY = "BILLING_CITY",
  BILLING_SUGGESTIONS = "BILLING_SUGGESTIONS",
  BILLING_HINT = "BILLING_HINT",
  BILLING_SUGGESTION_LIST = "BILLING_SUGGESTION_LIST",
  BILLING_COUNTRY = "BILLING_COUNTRY",
  BILLING_CLOSE_BUTTON = "BILLING_CLOSE_BUTTON",

  PAYER_ADDRESS_FIELD = "PAYER_ADDRESS_FIELD",
  PAYER_STREET = "PAYER_STREET",
  PAYER_POSTAL_CODE = "PAYER_POSTAL_CODE",
  PAYER_CITY = "PAYER_CITY",
  PAYER_SUGGESTIONS = "PAYER_SUGGESTIONS",
  PAYER_HINT = "PAYER_HINT",
  PAYER_SUGGESTION_LIST = "PAYER_SUGGESTION_LIST",
  PAYER_COUNTRY = "PAYER_COUNTRY",
  PAYER_CLOSE_BUTTON = "PAYER_CLOSE_BUTTON",
}
